// Only explicitly public server copy and known local failures are user-visible.
// Unknown exception messages, codes, SQL and vendor diagnostics never become UI text.
export function displayError(error = {}, fallback = '连接暂不可用，请重试原请求；不要重复提交控制操作。') {
  if (!error) return fallback;
  if (error.silent) return '';
  if (typeof error.displayMessage === 'string' && error.displayMessage.trim()) return error.displayMessage;
  switch (error.message) {
    case 'ACCOUNT_CHANGED': return '账号或服务器已变化，请重新进入Ai助理。';
    case 'AUTH_UNAVAILABLE': return '验证服务暂不可用，可稍后重试。';
    case 'CLIENT_UNSUPPORTED': return '客户端无法显示这条结果，请更新后重试。';
    default: return fallback;
  }
}
